import { render, staticRenderFns } from "./deliveryFeeEdit.vue?vue&type=template&id=8f9a9828&scoped=true&"
import script from "./deliveryFeeEdit.vue?vue&type=script&lang=js&"
export * from "./deliveryFeeEdit.vue?vue&type=script&lang=js&"
import style0 from "./deliveryFeeEdit.vue?vue&type=style&index=0&id=8f9a9828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a9828",
  null
  
)

export default component.exports